// import FirebaseLogin from './login/FirebaseLogin'
import NotFound from './NotFound'
import NotFoundAuth from './NotAuthRole'
import ForgotPassword from './ForgotPassword'
import LegalDocumentPage from './LegalDocumentPage'
// import FirebaseRegister from './register/FirebaseRegister'
import JwtRegister from './register/JwtRegister'
import JwtLogin from './login/JwtLogin'

const sessionRoutes = [
    {
        path: '/session/notAuthRole',
        component: NotFoundAuth,
    },
    {
        path: '/session/signup',
        component: JwtRegister,
    },
    {
        path: '/session/signin',
        component: JwtLogin,
    },
    {
        path: '/session/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/session/legal/terms',
        component: LegalDocumentPage,
    },
    {
        path: '/session/legal/privacy',
        component: LegalDocumentPage,
    },
    {
        path: '/session/legal/offer',
        component: LegalDocumentPage,
    },
    {
        path: '/session/legal/marketing',
        component: LegalDocumentPage,
    },
    {
        path: '/session/404',
        component: NotFound,
    },
]

export default sessionRoutes
